

const initialState = {
    isAuth:false,
    user:null,
    error:false,
    newUser:false
}




export default function authReducer(state=initialState,action){
    switch(action.type){
        case "AUTH_SUCCESS":
        return {
            user:action.payload,
            isAuth:true,
            error:false,
            newUser:false
        }
        case "AUTH_FAILED":
            return {
                user:null,
                isAuth:false,
                error:false,
                newUser:false
            }
        case "AUTH_SUCCESS_FIRST":
            return{
                user:action.payload,
                isAuth:true,
                error:false,
                newUser:true
            }
        default :
        return state;
    }
}